<app-navbar></app-navbar>
<div class="error-page">
  <div class="error-card">
    <div class="error-code">404</div>
    <h1 class="error-title">Page Not Found</h1>
    <p class="error-message">
      The page you're looking for doesn't exist or has been moved.
    </p>
    <a routerLink="/" class="error-btn">Return to Home</a>
  </div>
</div>
